import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import config from '../../config';
import '../../styles/avatar.scss';
import OnlineStatus from '../chat/OnlineStatus';

class Avatar extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      useAvatar: true,
    };
  }

  render() {
    const { user, width, status, onClick } = this.props;

    return (
      <div className="avatar-wrapper">
        <div className="avatar-container" onClick={onClick}>
          <div className="avatar-image">
            {this.state.useAvatar && user.avatar ? (
              <img
                src={`${config.apiUrl}/avatar?f=${user.avatar}`}
                onError={() => { this.setState({ useAvatar: false }); }}
                alt="Avatar"
                width={width}
              />
            ) : (
              <i className="zmdi zmdi-account-circle" />
            )}
          </div>
        </div>
        {status && <OnlineStatus status={status} />}
      </div>

    );
  }
}

Avatar.defaultProps = {
  width: 40,
};

Avatar.propTypes = {
  user: PropTypes.object,
  width: PropTypes.number,
  onClick: PropTypes.func,
  status: PropTypes.string,
};

export default Avatar;
